import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { Colors } from '../../../theme/Colors';
import { Typography } from '../../../theme/Typography';
import { Text } from '../../display/Text';
import { Img } from '../../display/Img/Img';
const breakpoints = {
    tablet: 768,
    desktop: 1230,
};
const mapV4ToV5Color = (color) => {
    const colorMap = {
        [Colors.lava10]: Colors.cream,
        [Colors.ocean10]: Colors.acidWash,
        [Colors.sun10]: Colors.neutral200,
        [Colors.white]: Colors.neutral100,
    };
    return colorMap[color] || color;
};
const Styles = labelStyles('OneColumnBlock', {
    root: (backgroundColor = 'neutral100') => [
        css `
      background-color: ${mapV4ToV5Color(Colors[backgroundColor])};
      padding: 20px;
      @media screen and (min-width: ${breakpoints.tablet}px) {
        padding: 40px 30px;
      }
      @media screen and (min-width: ${breakpoints.desktop}px) {
        padding: 50px 30px;
      }
    `,
    ],
    content: [
        css `
      margin: 0 auto;
      text-align: center;
      max-width: 1170px;
    `,
    ],
    text: (textAlign) => css `
    text-align: ${textAlign};
    max-width: 720px;
    margin-left: ${textAlign === 'center' || textAlign === 'right'
        ? 'auto'
        : 0};
    margin-right: ${textAlign === 'center' ? 'auto' : 0};
  `,
    headingContainer: [
        css `
      ${Typography.pageHeader5}

      @media screen and (min-width: ${breakpoints.desktop}px) {
        ${Typography.pageHeader5}
      }
    `,
    ],
    description: [
        css `
      margin-top: 20px;
      ${Typography.smallPrint1}
      color: ${Colors.neutral700};

      @media screen and (min-width: ${breakpoints.tablet}px) {
        ${Typography.paragraph1Short}
      }
    `,
    ],
});
export const OneColumnBlock = ({ backgroundColor, altText = '', headingTag = 'h3', heading, description, imageUrl, textAlign = 'center', }) => {
    return (isolateComponent("div", { css: Styles.root(backgroundColor) },
        isolateComponent("div", { css: Styles.content }, imageUrl ? (isolateComponent(Img, { borderRadius: 0, src: imageUrl, alt: altText })) : (isolateComponent("div", { "data-testid": "Text", css: Styles.text(textAlign) },
            isolateComponent("div", { css: Styles.headingContainer },
                isolateComponent(Text, { type: "heading", color: "neutral800", tag: headingTag }, heading)),
            description && isolateComponent("div", { css: Styles.description }, description))))));
};
//# sourceMappingURL=OneColumnBlock.js.map
// @zapier/design-system@6.28.0 (14d5b99c8)
